export const typography = {
    default: `'Century Gothic', sans-serif`,
    thin: '300',
    regular: '400',
    bold: '700'
}